<template>
    <div class="modal fade" :id="'androidGooglePlayDialog' + idName" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false" style="width: 100%; height: 100%;">
        <div class="modal-dialog modal-dialog-scv" role="document" style="margin: 16px; align-items: stretch; max-width: inherit">
            <div class="modal-content modal-content-scv-googleplay" style="position: relative">
                <div class="modal-header modal-header-scv-cmn" :id="'androidGooglePlayDialogHeader' + idName">
                    <div class="modal-header-text-box-scv" style="width: 100%;">
                        <div class="modal-header-text-scv">アプリケーションの選択</div>
                    </div>
                    <div class="btn-scv-close">
                        <a class="btn-scv-close" href="#" role="button" data-bs-dismiss="modal">
                            <div class="icon-font-slategray">
                                <i class="icon-delete"></i>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="modal-body modal-body-scv">
                    <div style="margin-bottom: 12px;">
                        対象のアプリケーションを選択して、アプリケーションの詳細画面上の［選択］ボタンを押してください。
                    </div>
                    <div :id="'googlePlayContainer' + idName" style="border: 0.5px solid #E6EBF0;"></div>
                </div>
                <div class="modal-footer modal-footer-scv" :id="'androidGooglePlayDialogFooter' + idName">
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import $ from "jquery";
    import { MessageUtil } from '@/models/Message/MessageUtil';
    import { LoadingUtil } from 'lib-vue-v2/util';
    import { AndroidApplicationWrapper } from '@/models/Mobile/Android/AndroidApplicationWrapper'
    import { MessageText } from '@/models/Message/MessageText';
    import { BootstrapUtil } from 'lib-vue-v2/util';

    @Options({
        props: {
            idName: {type: String, required: true},   // モーダル内のID関連の名前
            getURLFunction: { type: Function },
            getAppFunction: { type: Function },
            blackPackageList: { type: Object, default: undefined }, // 現在登録済みのアプリケーション<ブラックリスト>( Set<string> )
            whitePackageList: { type: Object, default: undefined },  // 現在登録済みのアプリケーション<ホワイトリスト>( Set<string> )
            isBlackConfigList: { type: Boolean, default: false }, //メッセージ作成の判定のため。利用を禁止するアプリケーションを設定かどうか
        },
        components: {
        },
        emits: ['onOk']
    })

    /*
     * Google PLay のアプリ検索ダイアログクラス
     * 
     * 参照: https://developers.google.com/android/work/play/emm-api/managed-play-iframe
     * 
     * 使い方
        <AndroidGooglePlayDialog    @onOk="onApplicationSelected" 
                                    @onCancel="onApplicationSelectCanceled"
                                    :getURLFunction="this.getURLFunction"
                                    :getAppFunction="this.getAppFunction"
                                    />
     * 
     * props:   getURLFunction      : iframe 埋め込み時に渡すURLを取得する関数。型は  func(void): string 
     *          getAppFunction  : アプリケーション詳細情報を取得する関数。型は function(packageName: string): schema.AMAPI_Application
     * 
     * emit:    onOk                : [OK]ボタン押下ハンドラ。選択されたパッケージ名と、アプリケーション(schema.AMAPI_Application)が引数で渡されます。
     * 
     * */
    export default class AndroidGooglePlayDialog extends Vue {

        // props
        private idName!: string;

        // Google APIスクリプトがロードできたかどうか
        private isScriptLoaded = false;

        // 現在登録済みのアプリケーション（重複チェック用）
        private blackPackageList!: Set<string> | undefined;
        private whitePackageList!: Set<string> | undefined;
        
        //メッセージ作成の判定のため。利用を禁止するアプリケーションを設定かどうか
        private isBlackConfigList!: boolean ;

        /**
         * @brief   割り振られたIDを取得
         */
        public GetID(): string {
            return 'androidGooglePlayDialog' + this.idName;
        }

        /**
         * インスタンス生成後の処理
         */
        public created(): void {
            let bExists = false;
            for (let i = 0; i < document.head.childElementCount; i++) {
                const target = document.head.children[i];
                if (target instanceof HTMLScriptElement) {
                    if ("https://apis.google.com/js/api.js" == target.src) {
                        bExists = true;
                        break;
                    }
                }
            }

            if (!bExists) {
                // vueコンポーネントの<template>部分で <script>での読み込みはできず、htmlにも書きたくないので仕方なく動的に。
                const script = document.createElement('script');
                script.src = 'https://apis.google.com/js/api.js';
                script.onload = () => {
                    this.isScriptLoaded = true;
                }

                // 追加はするが削除はしない
                document.head.appendChild(script);
            }
        }

        /**
         * マウント後の処理
         */
        public mounted(): void {
            // 高さ調整
            const minheight = this.calciFrameHeight();
            $('#googlePlayContainer' + this.idName).css('height', minheight);

            // リサイズハンドラ登録
            window.addEventListener('resize', this.onResize);

            const el = document.getElementById('androidGooglePlayDialog' + this.idName);
            if(null != el) {
                // ダイアログ表示ハンドラ
                el.addEventListener('shown.bs.modal', async () => {
                    let url = "";
                    // iframe埋め込みのための URL を取得
                    LoadingUtil.Start();
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    const res = await this.getURLFunction();
                    LoadingUtil.Stop();

                    // 成功
                    if (res.status == 200) {
                        url = res.data;
                        if ((url != null) && (0 < url.length)) {

                            // iframeの高さ計算
                            const height = this.calciFrameHeight();
                            const heightText = "height: " + height.toString() + "px";

                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            var gapi = window.gapi;
                            gapi.load('gapi.iframes', () => {
                                var options = {
                                    'url': url,
                                    'where': document.getElementById('googlePlayContainer' + this.idName),
                                    'attributes': { style: heightText, scrolling: 'yes' }
                                }

                                var iframe = gapi.iframes.getContext().openChild(options);

                                // [選択]された時のハンドラ
                                iframe.register('onproductselect', (event: any) => {
                                    this.onSelected(event.packageName);
                                }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
                            });
                        }
                        else {
                            MessageUtil.MessageBox(MessageText.dataGetErrorMessage, this.onShowFaild, null, MessageUtil.MB_ICON_ERROR);
                        }
                    }
                    else if (res.status == 401) {
                        // none(session timeout)
                        this.onShowFaild();
                        return;
                    }
                    else {
                        MessageUtil.MessageBox(MessageText.dataGetErrorMessage, this.onShowFaild, null, MessageUtil.MB_ICON_ERROR);
                        return;
                    }
                });

                // ダイアログ非表示ハンドラ
                el.addEventListener('hidden.bs.modal', () => {
                    // 次回表示の為に iframeを クリア
                    $('#androidGooglePlayDialog' + this.idName + ' iframe').remove();
                });
            }
        }

        /**
         * アンマウント前の処理
         */
        public beforeUnmount(): void {
            // リサイズハンドラ登録
            window.removeEventListener('resize', this.onResize);
        }

        /*
         * iFrameの高さ計算(DOMマウント以前は呼び出さないこと)
         * */
        private calciFrameHeight(): number {

            // ウィンドウの高さ
            let windowHeight = $(window).height();
            if (windowHeight == null) {
                windowHeight = 600; // フェイルセーフ
            }

            // ヘッダーの高さ
            let headerHeight = $('#androidGooglePlayDialogHeader' + this.idName).height();
            if (null == headerHeight) {
                headerHeight = 100;
            }

            // フッターの高さ
            let footerHeight = $('#androidGooglePlayDialogFooter' + this.idName).height();
            if (null == footerHeight) {
                footerHeight = 100;
            }

            return windowHeight - headerHeight - footerHeight - 116; // 最後のは気持ち
        }

        /*
         * アプリケーション選択ハンドラ
         * */
        private async onSelected(packageName: string): Promise<void> {
            // 重複チェック
            if (undefined != this.blackPackageList) {
                if (this.blackPackageList.has(packageName.toLowerCase())) {
                    if (!this.isBlackConfigList) {
                        MessageUtil.MessageBox("「利用を禁止するアプリケーション（ブラックリスト）」に登録されているアプリケーションのため、登録できません。", this.onMessageOk, null, MessageUtil.MB_ICON_WARNING);
                    }
                    else {
                        MessageUtil.MessageBox("すでに同じアプリケーションが登録されています。", this.onMessageOk, null, MessageUtil.MB_ICON_WARNING);
                    }
                    return;
                }
            }
            if (undefined != this.whitePackageList) {
                if (this.whitePackageList.has(packageName.toLowerCase())) {
                    if (this.isBlackConfigList) {
                        MessageUtil.MessageBox("「利用設定するアプリケーション」に登録されているアプリケーションのため、登録できません。", this.onMessageOk, null, MessageUtil.MB_ICON_WARNING);
                    }
                    else {
                        MessageUtil.MessageBox("すでに同じアプリケーションが登録されています。", this.onMessageOk, null, MessageUtil.MB_ICON_WARNING);
                    }
                    return;
                }
            }

            LoadingUtil.Start();
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const res = await this.getAppFunction(packageName);
            LoadingUtil.Stop();

            if (res.status == 200) {
                // 親へ通知して画面を閉じる
                this.$emit('onOk', packageName, Object.assign(new AndroidApplicationWrapper(), res.data));
                BootstrapUtil.hideModal(this.GetID());
            }
            else if (res.status == 401) {
                // none(session timeout)
            }
            else {
                MessageUtil.MessageBox(MessageText.dataGetErrorMessage, this.onMessageOk, null, MessageUtil.MB_ICON_ERROR);
            }
        }

        public onMessageOk(): void {
            // none
        }

        /*
         * 表示に失敗
         */
        public onShowFaild(): void {
            // 表示に失敗したときは画面を閉じる
            BootstrapUtil.hideModal('androidGooglePlayDialog' + this.idName);
        }

        public onResize(): void {
            const height = this.calciFrameHeight();
            $('#googlePlayContainer' + this.idName).css('height', height);
            $('#googlePlayContainer' + this.idName + ' iframe').css('height', height);
        }
    }
</script>

<style>
    @import "../../../assets/css/MobileAndroidCommon.css";
</style>
